import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      maxWidth: 400,
      margin: 16,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    title: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: MIDDLE_MARGIN,
      fontSize: 24,
      lineHeight: 1.2,
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN,
        fontSize: 28,
        lineHeight: '34px',
      },
    },
    description: {
      color: colorsPalette.white,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: MIDDLE_MARGIN,
      fontSize: 18,
      lineHeight: 1.4,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    buttonsWrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& button': {
        marginBottom: SMALL_MARGIN,
      },
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        '& button:last-child': {
          marginLeft: SMALL_MARGIN,
        },
      },
    },
    btn: {
      boxShadow: 'none',
      borderColor: 'transparent',
      '&:hover': {
        boxShadow: 'none',
        borderColor: 'transparent',
        background: 'transparent',
        color: colorsPalette.white,
        textDecoration: 'underline',
      },
    },
    joinBtn: {
      margin: '0 auto',
    },
  }),
);

export default useStyles;
